// /src/pages/Info.jsx

import React, { useState, useRef } from 'react';
import AboutTab from './publicTabs/AboutUsTab';
import PolicyTab from './publicTabs/PolicyTab';
import AllianceTab from './publicTabs/AllianceTab';
import PublicTocPanel from '../components/PublicTocPanel';

function InfoPage() {
  const [currentTab, setCurrentTab] = useState('policy');
  const [forceRender, setForceRender] = useState(0);
  const [publicTocVisible, setPublicTocVisible] = useState(false);
  
  const tocState = useRef({
    showPublicToc: false,
    toc: [],
    tocVisible: false,
    setTocVisible: null,
    containerRef: null
  });

  const handleTocReady = (data) => {
    tocState.current = data;
    setForceRender(n => n + 1);
  };

  return (
    <div>
      <div className="title-container margin-top-spacer-60">

        {/* onglet Policy */}
        <div
          onClick={() => setCurrentTab('policy')}
          className={`trapezoid-border3 ${currentTab === 'policy' ? 'active' : ''}`}
        >
          <a className="trapezoid-title">
            <span>Policy</span>
          </a>
        </div>

        {/* onglet About */}
        <div
          onClick={() => setCurrentTab('about')}
          className={`trapezoid-border3 ${currentTab === 'about' ? 'active' : ''}`}
        >
          <a className="trapezoid-title">
            <span>About Us</span>
          </a>
        </div>

        {/* onglet Alliance */}
        <div
          onClick={() => setCurrentTab('alliance')}
          className={`trapezoid-border3 ${currentTab === 'alliance' ? 'active' : ''}`}
        >
          <a className="trapezoid-title">
            <span>Alliance</span>
          </a>
        </div>
      </div>

      {/* TOC */}
        {tocState.current.showPublicToc && tocState.current.tocVisible && (
        <>
            <PublicTocPanel
                toc={tocState.current.toc}
                containerRef={tocState.current.containerRef}
                onClose={() => tocState.current.setTocVisible(false)}
            />
        </>
        )}


       <div className={`public-container glass-card ${publicTocVisible ? 'public-container-shifted' : ''}`}>
        {currentTab === 'policy' && (
          <PolicyTab onTocReady={handleTocReady} onTocVisibleChange={setPublicTocVisible} />
        )}

        {currentTab === 'about' && (
          <AboutTab onTocReady={handleTocReady} onTocVisibleChange={setPublicTocVisible} />
        )}

        {currentTab === 'alliance' && (
          <AllianceTab onTocReady={handleTocReady} onTocVisibleChange={setPublicTocVisible} />
        )}
      </div>
    </div>
  );
}

export default InfoPage;
